import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { AccountCategory, AccountMembershipRole, Module, useGetAccountQuery, useGetUserQuery } from '~/types/types';
import { useShowDebugging } from '~/functions/accounts';
import { usePortfolioReviewContext } from '~/functions/review';
import HeaderUserMenu from '~/components/ix/HeaderUserMenu.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderPortfolio',
  setup: function setup(__props) {
    var _useNuxtApp = useNuxtApp(),
      $auth = _useNuxtApp.$auth;
    var _useGetAccountQuery = useGetAccountQuery({}, computed(function () {
        return {
          enabled: $auth.loggedIn
        };
      })),
      result = _useGetAccountQuery.result,
      loading = _useGetAccountQuery.loading;
    var _useGetUserQuery = useGetUserQuery(),
      userResult = _useGetUserQuery.result;
    var user = computed(function () {
      var _userResult$value;
      return (_userResult$value = userResult.value) === null || _userResult$value === void 0 ? void 0 : _userResult$value.getUser;
    });
    var account = computed(function () {
      var _result$value;
      return ((_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.getAccount) || {
        name: '',
        type: AccountCategory.Venture
      };
    });
    var showSuspendedBanner = computed(function () {
      var _user$value, _account$value;
      return Boolean((_user$value = user.value) === null || _user$value === void 0 ? void 0 : _user$value.isAdmin) && Boolean((_account$value = account.value) === null || _account$value === void 0 ? void 0 : _account$value.isSuspended);
    });
    var isCustomerSuspended = computed(function () {
      var _user$value2, _account$value2;
      return !Boolean((_user$value2 = user.value) === null || _user$value2 === void 0 ? void 0 : _user$value2.isAdmin) && Boolean((_account$value2 = account.value) === null || _account$value2 === void 0 ? void 0 : _account$value2.isSuspended);
    });
    var hasModule = function hasModule(moduleName) {
      var _result$value2, _result$value2$getAcc, _result$value2$getAcc2;
      return !!((_result$value2 = result.value) !== null && _result$value2 !== void 0 && (_result$value2$getAcc = _result$value2.getAccount) !== null && _result$value2$getAcc !== void 0 && (_result$value2$getAcc2 = _result$value2$getAcc.modules) !== null && _result$value2$getAcc2 !== void 0 && _result$value2$getAcc2.includes(moduleName));
    };
    var accounts = computed(function () {
      var _user$value3;
      return (user === null || user === void 0 ? void 0 : (_user$value3 = user.value) === null || _user$value3 === void 0 ? void 0 : _user$value3.accounts) || [];
    });
    var showAccountSelection = computed(function () {
      var _accounts$value;
      return (accounts === null || accounts === void 0 ? void 0 : (_accounts$value = accounts.value) === null || _accounts$value === void 0 ? void 0 : _accounts$value.length) > 1;
    });
    var _usePortfolioReviewCo = usePortfolioReviewContext(),
      showReviewerShell = _usePortfolioReviewCo.showReviewerShell,
      isAccountAdmin = _usePortfolioReviewCo.isAccountAdmin,
      isEditor = _usePortfolioReviewCo.isEditor,
      hasReviewModule = _usePortfolioReviewCo.hasReviewModule,
      membershipRoles = _usePortfolioReviewCo.membershipRoles;
    var showDebugging = useShowDebugging();
    var isIxAdminSession = computed(function () {
      var _user$value4, _user$value5;
      return Boolean((_user$value4 = user.value) === null || _user$value4 === void 0 ? void 0 : _user$value4.isAdmin) && !((_user$value5 = user.value) !== null && _user$value5 !== void 0 && _user$value5.isImpersonated);
    });
    var showAccountUsersTab = computed(function () {
      return isIxAdminSession.value || isAccountAdmin.value;
    });
    var showEditorTabs = computed(function () {
      return isIxAdminSession.value || isEditor.value;
    });
    var showReviewTab = computed(function () {
      return hasReviewModule.value && membershipRoles.value.includes(AccountMembershipRole.Reviewer);
    });
    var headers = computed(function () {
      var _account$value3;
      if (showReviewerShell.value && !isIxAdminSession.value) {
        var reviewerHeaders = [{
          label: 'Review',
          link: 'portfolio-review',
          showForModules: true
        }];
        if (showAccountUsersTab.value) {
          reviewerHeaders.push({
            label: 'Users',
            link: 'admin-users',
            showForModules: true,
            isAdmin: isIxAdminSession.value
          });
        }
        return reviewerHeaders;
      }
      var editorHeaders = [{
        label: 'Dashboard',
        link: 'portfolio-dashboard',
        showForModules: showEditorTabs.value && hasModule(Module.Esg)
      }, {
        label: 'ESG',
        link: 'portfolio-esgList',
        showForModules: showEditorTabs.value && hasModule(Module.Esg)
      }, {
        label: 'Impact',
        link: 'portfolio-impactGoalList',
        showForModules: showEditorTabs.value && hasModule(Module.ImpactGoal)
      }, {
        label: 'KPIs',
        link: 'portfolio-metrics',
        showForModules: showEditorTabs.value && hasModule(Module.Metrics)
      }, {
        label: 'Annotation',
        link: 'portfolio-annotation',
        showForModules: showEditorTabs.value && hasModule(Module.Annotation)
      }, {
        label: 'Funds',
        link: 'portfolio-funds',
        showForModules: showEditorTabs.value && hasModule(Module.Sfdr)
      }, {
        label: 'Review',
        link: 'portfolio-review',
        showForModules: showReviewTab.value
      }, {
        label: 'Request',
        link: 'portfolio-requests',
        showForModules: showDebugging.value && showEditorTabs.value,
        isAdmin: true
      }, {
        label: 'Accounts',
        link: 'admin-accounts',
        showForModules: isIxAdminSession.value || showEditorTabs.value && ((_account$value3 = account.value) === null || _account$value3 === void 0 ? void 0 : _account$value3.type) === AccountCategory.Portfolio
      }, {
        label: 'Users',
        link: 'admin-users',
        showForModules: showAccountUsersTab.value,
        isAdmin: isIxAdminSession.value
      }, {
        label: 'KPIs MGM',
        link: 'admin-kpis',
        showForModules: isIxAdminSession.value,
        isAdmin: true,
        children: [{
          label: 'Datapoint',
          link: 'admin-kpis-datapoint',
          showForModules: isIxAdminSession.value,
          isAdmin: true
        }, {
          label: 'Aggregated',
          link: 'admin-kpis-aggregated',
          showForModules: isIxAdminSession.value,
          isAdmin: true
        }]
      }, {
        label: 'Categories',
        link: 'admin-categories',
        showForModules: isIxAdminSession.value,
        isAdmin: true
      }, {
        label: 'ESG MGM',
        link: 'admin-esgs',
        showForModules: isIxAdminSession.value,
        isAdmin: true
      }, {
        label: 'Section MGM',
        link: 'admin-sections',
        showForModules: isIxAdminSession.value,
        isAdmin: true
      }, {
        label: 'Fund Reports',
        link: 'admin-fundreports',
        showForModules: isIxAdminSession.value,
        isAdmin: true
      }, {
        label: 'Company Info',
        link: 'admin-companyinfo',
        showForModules: isIxAdminSession.value,
        isAdmin: true
      }, {
        label: 'IRO',
        link: 'admin-iro',
        showForModules: isIxAdminSession.value,
        isAdmin: true
      }, {
        label: 'Fund MGM',
        link: 'admin-funds',
        showForModules: isIxAdminSession.value,
        isAdmin: true
      }, {
        label: 'Audit',
        link: 'admin-audits',
        showForModules: isIxAdminSession.value,
        isAdmin: true
      }, {
        label: 'Feedback',
        link: 'admin-feedbacks',
        showForModules: isIxAdminSession.value,
        isAdmin: true
      }];
      return editorHeaders.filter(function (header) {
        return header.showForModules;
      });
    });
    var activeTab = ref('portfolio-dashboard');
    var onInput = function onInput(v) {
      sessionStorage.setItem('ix-account-id', v);
      window.location.href = '/';
    };
    var selectedAccount = computed(function () {
      return sessionStorage.getItem('ix-account-id');
    });
    return {
      __sfc: true,
      $auth: $auth,
      result: result,
      loading: loading,
      userResult: userResult,
      user: user,
      account: account,
      showSuspendedBanner: showSuspendedBanner,
      isCustomerSuspended: isCustomerSuspended,
      hasModule: hasModule,
      accounts: accounts,
      showAccountSelection: showAccountSelection,
      showReviewerShell: showReviewerShell,
      isAccountAdmin: isAccountAdmin,
      isEditor: isEditor,
      hasReviewModule: hasReviewModule,
      membershipRoles: membershipRoles,
      showDebugging: showDebugging,
      isIxAdminSession: isIxAdminSession,
      showAccountUsersTab: showAccountUsersTab,
      showEditorTabs: showEditorTabs,
      showReviewTab: showReviewTab,
      headers: headers,
      activeTab: activeTab,
      onInput: onInput,
      selectedAccount: selectedAccount,
      HeaderUserMenu: HeaderUserMenu
    };
  }
});